// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanLayoutWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete,
  RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFloorPlanLayoutUploadRequestWebDto,
  UserPropertyFloorPlanLayoutUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface DeleteParams {
  floorPlanId: string;
}
interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete_Args
>;

/**
 * Delete a property layout
 */
export const useRentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_delete(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyFloorPlanLayoutUploadRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyFloorPlanLayoutUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Args
>;

/**
 * Upload a property layout
 */
export const useRentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
